export default __webpack_public_path__ + "static/media/TJK.bd25d5fe.svg";